import { render } from "./AppTechnicalPopups.vue?vue&type=template&id=6a1b95d4"
import script from "./AppTechnicalPopups.vue?vue&type=script&lang=js"
export * from "./AppTechnicalPopups.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__